import { render } from "./TopHeader.vue?vue&type=template&id=07f32751&scoped=true"
import script from "./TopHeader.vue?vue&type=script&lang=js"
export * from "./TopHeader.vue?vue&type=script&lang=js"

import "./TopHeader.vue?vue&type=style&index=0&id=07f32751&scoped=true&lang=css"

import exportComponent from "C:\\Users\\pc07\\Documents\\GitHub\\lezione-online-test\\gatthotel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f32751"]])

export default __exports__